/**
 * @module manifest/groupRegistry
 * @description 配置分组组件注册表 — 由 REGISTERED_GROUP_DEFS 派生
 */

import {
  definitionsToGroupRegistry,
  type IChartSettingsGroupComponentProps,
} from './defineGroup';
import { REGISTERED_GROUP_DEFS } from './groupRegistryDefs';

export type { IChartSettingsGroupComponentProps };

export const groupRegistry = definitionsToGroupRegistry(REGISTERED_GROUP_DEFS);

export function getGroupRegistryKeys(): string[] {
  return Object.keys(groupRegistry);
}
